<template>
  <div class="panel">
    <div class="panel-heading">
      <h3 class="panel-title text-center">
        Статистика посещения системы учащимися
      </h3>
    </div>
    <div class="panel-body">
      <div class="report-content">
        <span v-if="loading" class="error loading status_padding">
          <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i> Загрузка
          данных...
        </span>

        <span v-else-if="error" class="error status_padding">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Ошибка
          загрузки данных
        </span>

        <span v-else-if="isStatsEmpty">
          <p class="error">Нет данных для статистики</p>
        </span>
        <GChart
          v-else
          type="ColumnChart"
          :data="chartData"
          :options="chartOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts/legacy";

export default {
  name: "DayStatsUsersDiagram",
  data() {
    return {
      loading: true,
      error: false,
      days: [],
      chartOptions: {
        vAxis: {
          minValue: 0,
          format: "#",
        },
        legend: { position: "bottom" },
        width: "100%",
        height: 400,
      },
    };
  },
  computed: {
    chartData() {
      return [["Дни", "Количество людей"], ...this.days];
    },
    isDataEmpty() {
      return this.days.length === 0;
    },
    isPointsEmpty() {
      return this.days.every((point) => {
        return point[1] === 0;
      });
    },
    isStatsEmpty() {
      return this.isDataEmpty || this.isPointsEmpty;
    },
  },
  components: {
    GChart,
  },
  methods: {
    get_data() {
      axios
        .get("/widgets/DayStatsUsers")
        .then((response) => {
          this.days = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.error = true;
        });
    },
  },
  mounted() {
    this.get_data();
  },
};
</script>

<style scoped>
.error,
.loading {
  display: inline-block;
}
.error i,
.loading i {
  margin-right: 5px;
}

.error {
  font-weight: bold;
}
</style>
